module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeable",
    on: {
      "mouseover": function($event) {
        _vm.show = true
      },
      "mouseout": function($event) {
        _vm.show = false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.containerImg()
    },
    on: {
      "error": _vm.addDefaultSrc
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('span', {
    staticClass: "tooltip"
  }, [_vm._v(" \n    " + _vm._s(_vm.placeable.name) + "\n    "), _c('br'), _vm._v("\n    " + _vm._s(_vm.placeable.slot) + "\n    ")]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-24598a2f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Container.vue
// module id = 235
// module chunks = 2